import { render, staticRenderFns } from "./index.vue?vue&type=template&id=e7e446a6"
var script = {}


/* normalize component */
import normalizer from "!../../../../content-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports